import axios from "../../config/axiosConfig";
import {
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_REQUEST,
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_SUCCESS,
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_FAILURE,
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_REQUEST,
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_SUCCESS,
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_FAILURE
} from "../types/delivery-challan-register-return-yarn-report-types";

export const getAllDeliveryChallanReturnInvoiceNumberOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllDeliveryChallanReturnInvoiceNumberOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllAccountOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllAccountOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllItemsOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllItemsOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllVehiclesOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllVehiclesOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllDeliveryAccountOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllDeliveryAccountOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllAreaOfDeliveryChallanReturnYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-return-register-report/getAllAreaOfDeliveryChallanReturnYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getDeliveryChallanRegisterReturnYarnReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/delivery-challan-return-register-report/yarn?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallanRegisterReturnYarnFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_REQUEST });
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/delivery-challan-return-register-report/filter-detail/yarn?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching delivery challan Register Report:", error);
        dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching delivery challan Register Report:", error);
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearDeliveryChallanRegisterReturnYarnReport = () => {
  return async (dispatch) => {
    dispatch({ type: DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_SUCCESS, payload: {} });
  }
}
